
import React, { useState, useEffect } from 'react';
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
import RecipeFeedbackForm from '@/components/RecipeFeedbackForm';
import RecipeFeedbackList from '@/components/RecipeFeedbackList';
import { RecipeFeedback } from "@/types/recipe";
import { feedbackService } from "@/services/feedback";

interface RecipeFeedbackSectionProps {
  recipeId: string;
}

const RecipeFeedbackSection: React.FC<RecipeFeedbackSectionProps> = ({ recipeId }) => {
  const [feedbacks, setFeedbacks] = useState<RecipeFeedback[]>([]);
  const [loadingFeedbacks, setLoadingFeedbacks] = useState(true);

  useEffect(() => {
    loadFeedbacks();
  }, [recipeId]);

  const loadFeedbacks = async () => {
    if (recipeId) {
      setLoadingFeedbacks(true);
      try {
        const recipeFeedbacks = await feedbackService.getFeedbacksByRecipeId(recipeId);
        setFeedbacks(recipeFeedbacks);
      } catch (error) {
        console.error("Error loading feedbacks:", error);
      } finally {
        setLoadingFeedbacks(false);
      }
    }
  };

  return (
    <div className="mb-8" id="recipe-feedback">
      <h2 className="text-2xl font-semibold mb-6">Reviews & Comments</h2>
      
      {loadingFeedbacks ? (
        <div className="space-y-4">
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-24 w-full" />
        </div>
      ) : (
        <RecipeFeedbackList feedbacks={feedbacks} />
      )}
      
      <div className="mt-8 bg-muted p-6 rounded-lg">
        <h3 className="text-lg font-medium mb-4">Leave your feedback</h3>
        <RecipeFeedbackForm recipeId={recipeId} onFeedbackAdded={loadFeedbacks} />
      </div>
    </div>
  );
};

export default RecipeFeedbackSection;
